import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};

for (var i = 0; i < 256; i++) {
  var encodedByte = i.toString(16).toLowerCase();

  if (encodedByte.length === 1) {
    encodedByte = "0" + encodedByte;
  }

  SHORT_TO_HEX[i] = encodedByte;
  HEX_TO_SHORT[encodedByte] = i;
}
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */


export function fromHex(encoded) {
  if (encoded.length % 2 !== 0) {
    throw new Error("Hex encoded strings must have an even number length");
  }

  var out = new Uint8Array(encoded.length / 2);

  for (var i = 0; i < encoded.length; i += 2) {
    var encodedByte = encoded.substr(i, 2).toLowerCase();

    if (encodedByte in HEX_TO_SHORT) {
      out[i / 2] = HEX_TO_SHORT[encodedByte];
    } else {
      throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
  }

  return out;
}
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */

export function toHex(bytes) {
  var out = "";

  for (var i = 0; i < bytes.byteLength; i++) {
    out += SHORT_TO_HEX[bytes[i]];
  }

  return out;
}